import { useContext } from 'react';

import { UserRoleEnum } from '@app/user/constants';

import { AuthContext } from '../context';
import { State } from '../types/State';

export const useAuth = () => {
  const { state, updateState } = useContext(AuthContext);

  const user = state?.user as State['user'];

  const isAdmin = !!user && user.role === UserRoleEnum.admin;

  const isParent = !!user && user.role === UserRoleEnum.parent;

  const isSurrogate = !!user && user.role === UserRoleEnum.surrogate;

  const application = user?.applications ? user?.applications[0] : undefined;

  const questionnaire = user?.questionnaires ? user?.questionnaires[0] : undefined;

  return {
    user,
    updateState,
    isAdmin,
    isParent,
    isSurrogate,
    application,
    questionnaire,
    isSignedIn: !!state?.token,
  };
};
